import { Injectable } from '@angular/core';
import { ApiRequestService } from 'netsocial-lib/src/app/services/api-request/api-request.service';
import { Banner } from 'netsocial-lib/src/app/interfaces/banner';

// export interface GetBannerParams {
//   id: string;
//   clientId: Client['id'];
//   text: string;
//   date: string;
//   active: string;
//   header: string;
// }

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  constructor(private apiRequest: ApiRequestService) {}

  async getBanners(): Promise<Banner[]> {
    const response = await this.apiRequest.request('banners/get', {});
    const banners: Banner[] = response.results.data;
    return banners;
  }
}
